import { render, staticRenderFns } from "./CalculationPage.vue?vue&type=template&id=f89377c2&"
import script from "./CalculationPage.vue?vue&type=script&lang=js&"
export * from "./CalculationPage.vue?vue&type=script&lang=js&"
import style0 from "./CalculationPage.vue?vue&type=style&index=0&id=f89377c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports